/* ASETOS predictive search — custom dropdown backed by /search/suggest.json
   Works with the header's category <select> + <input name="q"> without
   relying on Dawn's <predictive-search> web component. */
(function () {
  'use strict';

  function setup(form) {

  var input = form.querySelector('input[name="q"]');
  var results = form.querySelector('.asetos-search-results');
  if (!input || !results) return;

  var SUGGEST_URL =
    (window.routes && window.routes.predictive_search_url) || '/search/suggest';
  var MIN_CHARS = 2;
  var DEBOUNCE_MS = 220;
  var timer = null;
  var lastQuery = '';
  var controller = null;

  function money(amount) {
    // /search/suggest.json returns prices in currency units ("3540.00"), NOT cents;
    // dividing by 100 showed R 35,40 for a R3,540 laptop.
    var v = parseFloat(amount) || 0;
    try {
      return v.toLocaleString('en-ZA', { style: 'currency', currency: 'ZAR' });
    } catch (e) {
      return 'R' + v.toFixed(2);
    }
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function open() {
    results.hidden = false;
    input.setAttribute('aria-expanded', 'true');
  }

  function close() {
    results.hidden = true;
    results.innerHTML = '';
    input.setAttribute('aria-expanded', 'false');
  }

  function renderLoading() {
    results.innerHTML =
      '<div class="asetos-ps-state">Searching&hellip;</div>';
    open();
  }

  function renderEmpty(query) {
    results.innerHTML =
      '<div class="asetos-ps-state">No matches for &ldquo;' +
      escapeHtml(query) +
      '&rdquo;.</div>' +
      '<a class="asetos-ps-all" href="/search?q=' +
      encodeURIComponent(query) +
      '">Search all products &rsaquo;</a>';
    open();
  }

  function renderResults(products, query) {
    if (!products.length) {
      renderEmpty(query);
      return;
    }
    var html = '<ul class="asetos-ps-list">';
    products.forEach(function (p) {
      var img = p.featured_image && p.featured_image.url ? p.featured_image.url : '';
      var price = p.price_min != null ? money(p.price_min) : '';
      html +=
        '<li role="option">' +
        '<a class="asetos-ps-item" href="' +
        escapeHtml(p.url) +
        '">' +
        (img
          ? '<img class="asetos-ps-thumb" src="' +
            escapeHtml(img) +
            '" alt="" width="44" height="44" loading="lazy">'
          : '<span class="asetos-ps-thumb asetos-ps-thumb--empty"></span>') +
        '<span class="asetos-ps-meta">' +
        '<span class="asetos-ps-title">' +
        escapeHtml(p.title) +
        '</span>' +
        (price ? '<span class="asetos-ps-price">' + price + '</span>' : '') +
        '</span>' +
        '</a>' +
        '</li>';
    });
    html += '</ul>';
    html +=
      '<a class="asetos-ps-all" href="/search?q=' +
      encodeURIComponent(query) +
      '">See all results &rsaquo;</a>';
    results.innerHTML = html;
    open();
  }

  function fetchSuggestions(query) {
    if (controller) controller.abort();
    controller = typeof AbortController !== 'undefined' ? new AbortController() : null;

    var url =
      SUGGEST_URL +
      '?q=' +
      encodeURIComponent(query) +
      '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';

    fetch(url, {
      headers: { Accept: 'application/json' },
      signal: controller ? controller.signal : undefined
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        if (query !== lastQuery) return; // a newer query superseded this one
        var products =
          (data &&
            data.resources &&
            data.resources.results &&
            data.resources.results.products) ||
          [];
        renderResults(products, query);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        close();
      });
  }

  input.addEventListener('input', function () {
    var query = input.value.trim();
    lastQuery = query;
    if (timer) clearTimeout(timer);
    if (query.length < MIN_CHARS) {
      close();
      return;
    }
    renderLoading();
    timer = setTimeout(function () {
      fetchSuggestions(query);
    }, DEBOUNCE_MS);
  });

  input.addEventListener('focus', function () {
    if (input.value.trim().length >= MIN_CHARS && results.innerHTML) open();
  });

  document.addEventListener('click', function (e) {
    if (!form.contains(e.target)) close();
  });

  input.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      close();
      input.blur();
    }
  });
  }

  document.querySelectorAll('.asetos-search').forEach(setup);
})();
